import { CheckRideRequestEntity } from "../../../meta-data/app-meta-data.service";

export interface SchoolSwapStudentResult {
    swapType: SchoolChangeApplicantSwapType;

    cancelledCheckrids: CheckRideRequestEntity[];
    newApplicantCheckride: CheckRideRequestEntity;
    originalApplicantCheckride?: CheckRideRequestEntity;
}

export enum SchoolChangeApplicantSwapType {
    cancel = 'cancel',
    swap = 'swap'
}